<div [formGroup]="formGroup">
    <div class="flex flex-row flex-wrap gap-2">
        <mat-form-field class="flex-auto" floatLabel="always">
            <mat-label i18n>Terms of Sale</mat-label>
            <mat-select formControlName="termsOfSale" (change)="userChange()" i18n-placeholder placeholder="Terms of Sale">
                <mat-option value="EXW">EXW</mat-option>
                <mat-option value="FCA">FCA</mat-option>
                <mat-option value="CFR">CFR</mat-option>
                <mat-option value="CIF">CIF</mat-option>
                <mat-option value="DAP">DAP</mat-option>
                <mat-option value="DDP">DDP</mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field class="flex-auto" floatLabel="always">
            <mat-label>Purpose</mat-label>
            <mat-select formControlName="purpose" (change)="userChange()" i18n-placeholder placeholder="Purpose">
                <mat-option value="SOLD" i18n>Sold</mat-option>
                <mat-option value="NOT_SOLD" i18n>Not Sold</mat-option>
                <mat-option value="GIFT" i18n>Gift</mat-option>
                <mat-option value="PERSONAL_EFFECTS" i18n>Personal Effects</mat-option>
                <mat-option value="REPAIR_AND_RETURN" i18n>Repair And Return</mat-option>
                <mat-option value="SAMPLE" i18n>Sample</mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field class="flex-auto" floatLabel="always">
            <mat-label i18n>Relationship</mat-label>
            <mat-select formControlName="relationship" (change)="userChange()" i18n-placeholder placeholder="Relationship">
                <mat-option value="RELATED" i18n>Related</mat-option>
                <mat-option value="NOT_RELATED" i18n>Not Related</mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field class="flex-auto" floatLabel="always">
            <mat-label i18n>Duties Payor</mat-label>
            <mat-select formControlName="dutiesPayor" (change)="userChange()" i18n-placeholder placeholder="Duties Payor">
                <mat-option value="SENDER" i18n>Sender</mat-option>
                <mat-option value="RECIPIENT" i18n>Recipient</mat-option>
                @if (thirdPartyAllowed()) {
                    <mat-option value="THIRD_PARTY" i18n>Third Party Account</mat-option>
                }
                <mat-option value="NOT_DUTIABLE" i18n>Not Dutiable</mat-option>
            </mat-select>
        </mat-form-field>
        @if (thirdPartyDuties()) {
            <mat-form-field class="flex-auto" floatLabel="always">
                <mat-label i18n>Duties Payor Account</mat-label>
                <input matInput formControlName="dutiesAccount" i18n-placeholder placeholder="Duties Payor Account">
            </mat-form-field>
        }
    </div>
    <app-shipment-commodities-table></app-shipment-commodities-table>
    <div class="customs-form mt-2" [class.active]="commercialInvoiceActive()">
        <mat-checkbox formControlName="commercialInvoice" (change)="userChange()" i18n>
            Commercial Invoice
        </mat-checkbox>
        @if (commercialInvoiceActive()) {
            <div class="flex flex-row gap-2 mx-2">
                <mat-form-field class="grow basis-1/3" floatLabel="always">
                    <mat-label i18n>Freight Amount</mat-label>
                    <input matInput type="number" formControlName="commercialInvoiceFreight" placeholder="Freight Amount">
                </mat-form-field>
                <mat-form-field class="grow basis-1/3" floatLabel="always">
                    <mat-label i18n>Insurance Amount</mat-label>
                    <input matInput type="number" formControlName="commercialInvoiceInsurance" placeholder="Insurance Amount">
                </mat-form-field>
                <mat-form-field class="grow basis-1/3" floatLabel="always">
                    <mat-label i18n>Surcharge Amount</mat-label>
                    <input matInput type="number" formControlName="commercialInvoiceSurcharge" placeholder="Surcharge Amount">
                </mat-form-field>
            </div>
            <div class="flex flex-row gap-2 mx-2">
                <mat-form-field class="grow" floatLabel="always">
                    <mat-label i18n>Comments</mat-label>
                    <input matInput formControlName="comments" placeholder="Comments">
                </mat-form-field>
            </div>
        }
    </div>
</div>
